import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Color } from '../../assets/color';

const DatatableHeading = ({ title, sub_title, url, url_name }) => {
    const navigate = useNavigate();

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                    <div style={{ fontSize: "25px", fontWeight: "500", background: "linear-gradient(to right, #6653E8, #9544EB)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", display: "inline-block" }}>{title}</div>
                    {sub_title && <p style={{ fontSize: '15px', color: '#72727B' }}>{sub_title}</p>}
                </div>

                {url && url_name && <div onClick={() => navigate(url)} style={{ fontSize: '14.5px', fontWeight: '500', padding: '10px 20px 9px 20px', borderRadius: '20px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: "#FFF", cursor: 'pointer' }}>{url_name}</div>}
            </div>
        </>
    )
}

export default DatatableHeading;